import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import OurServices from "../component/pricing/OurServices";
import PricingPlan from "../component/pricing/PricingPlan";

const Pricing = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#plans") {
      const el = document.getElementById("plans");
      if (el) {
        setTimeout(() => {
          const y = el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <Box sx={{ bgcolor: "#F8FAFF" }}>
      <OurServices />
      <PricingPlan />
    </Box>
  );
};

export default Pricing;
